const BANNER_RIGHTS = ['admin_financial_services', 'reports'];

export function useHasBannerRights() {
  return BANNER_RIGHTS.every((right) => window.merchantos.session.hasRight(right));
}
